/* eslint-disable */ import { DomainBuilder, DomainComponentOpticBuilder, InvariantBuilder, RecipeFactoryBuilder, createConstantExpressionFactory, createCustomExpressionFactory, createCustomInvariantFactory, createRelationFactory } from '@salsita-ai/platform-project-sdk/domain';
import { BackendData, FrontendData, PublishedData, SessionData } from './application-types.js';
import { $entityReflections, constants } from './enhanced-model.js';
import { AnyDomainEntity, RootEntity, aliases, entities, modelVersion } from './model/index.js';
const implementRelation = createRelationFactory(aliases);
export const relationExpressions = {
    Shorts: {
        $parts: implementRelation({
            target: 'Part',
            kind: 'allOfType',
            cardinality: '1-N'
        }),
        $leftLeg: implementRelation({
            target: 'LeftLeg',
            kind: 'allOfType',
            cardinality: '1-1'
        }),
        $rightLeg: implementRelation({
            target: 'RightLeg',
            kind: 'allOfType',
            cardinality: '1-1'
        }),
        $leftThighBand: implementRelation({
            target: 'LeftThighBand',
            kind: 'allOfType',
            cardinality: '0-1'
        }),
        $rightThighBand: implementRelation({
            target: 'RightThighBand',
            kind: 'allOfType',
            cardinality: '0-1'
        }),
        $waistband: implementRelation({
            target: 'Waistband',
            kind: 'allOfType',
            cardinality: '1-1'
        }),
        $drawstring: implementRelation({
            target: 'Drawstring',
            kind: 'allOfType',
            cardinality: '1-1'
        })
    },
    Part: {
        $shorts: implementRelation({
            target: 'Shorts',
            kind: 'allOfType',
            cardinality: '1-1'
        })
    }
};
export const constantExpressions = createConstantExpressionFactory({} // insert expression metas here, once ready
)(constants);
export const createRecipe = RecipeFactoryBuilder.forAliases(aliases).forEntities(AnyDomainEntity.reflections).withDefaults({}).build();
const staticViolations = {
    Shorts: {
        linerRequiredForTanThroughFabric: {
            type: 'missingLiner',
            message: 'Mesh liner is required for tan through fabric',
            severity: 'fatal'
        }
    }
};
export const implementCustomInvariants = createCustomInvariantFactory()(staticViolations);
export const invariantBuilder = new InvariantBuilder(aliases);
export const attachComponent = DomainComponentOpticBuilder.from(aliases);
export const implementCustomExpressions = createCustomExpressionFactory({} // TODO pass in meta-data once we have them
);
export const dataExpressions = implementCustomExpressions({});
export const domainBuilder = DomainBuilder.from(entities, aliases, $entityReflections, RootEntity.types, modelVersion, PublishedData, SessionData, FrontendData, BackendData, false).withExpressions(constantExpressions).withExpressions(relationExpressions).withExpressions(dataExpressions);

//# sourceMappingURL=implementation.js.map